export default __webpack_public_path__ + "static/media/portfolio-4.668ce3e6.jpg";